<template>
  <div id="content-wrapper">
    <form @submit.prevent>
      <b-form-group label-for="filterBy" class="border-bottom-form">
        <div class="row justify-content-space-between m-0">
          <div class="col-xl-5 col-lg-6 p-0">
            <b-form-input
              v-if="false"
              v-model="requestInformation.filterBy"
              id="filterBy"
              type="text"
              required
              @keyup.enter="layNguoiDungGomQuyenPhanTrang"
              placeholder="Nhập họ tên, tên đăng nhập"
            />
            <div class="d-flex align-items-center">
              <div class="font-weight-bold">Tên đơn vị</div>
              <div class="d-flex flex-1-0 ml-2">
                <treeselect
                  :clearable="true"
                  :normalizer="normalizer"
                  :options="danhSachDonViBanDau || []"
                  :show-count="true"
                  :value="requestInformation.donViId"
                  no-children-text="Không có đơn vị con"
                  placeholder="Chọn đơn vị"
                  ref="chonCayDonVi"
                  v-model="requestInformation.donViId"
                  @input="layNguoiDungGomQuyenPhanTrang"
                  class="tree-don-vi flex-1-0"
                >
                  <label
                    :class="labelClassName"
                    slot="option-label"
                    slot-scope="{
                      node,
                      shouldShowCount,
                      count,
                      labelClassName,
                      countClassName,
                    }"
                  >
                    {{ node.label }}
                    <span
                      :class="countClassName"
                      v-if="shouldShowCount && count > 0"
                      >({{ count }})</span
                    >
                  </label>
                </treeselect>
                <b-form-checkbox
                  v-model="requestInformation.isGetAll"
                  class="mt-2 ml-3"
                  @change="onChangeGetAll"
                >
                  Tất cả
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <base-button
              v-if="false"
              class="d-block ml-3"
              button="Tìm kiếm"
              @click="layNguoiDungGomQuyenPhanTrang()"
            />
            <base-button
              @click="openImport"
              button="Import"
              v-if="hasPermissionUser(PERMISSION_NAME.IMPORT.IMPORT_CAN_BO)"
              variant="info"
            />
            <base-button
              class="btn btn-blue"
              :disabled="isLoadingExport"
              @click="openExport"
              variant="info"
              v-if="hasPermissionUser(PERMISSION_NAME.IMPORT.EXPORT_NGUOI_DUNG)"
              button="Export"
            >
            </base-button>
            <base-button
              button="Thêm mới"
              @click="themMoi"
              v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.THEM)"
            >
            </base-button>
          </div>
        </div>
      </b-form-group>
    </form>
    <div class="box-form-result">
      <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
      <DataTable
        :value="nguoiDungGomQuyenNoiBo"
        :loading="isLoadingTable"
        dataKey="id"
        class="p-datatable-customers"
      >
        <Column
          field="id"
          dataKey="id"
          headerStyle="width: 40px"
          headerClass="p-2"
          header="STT"
          bodyStyle="text-align: center"
        >
          <template #filter> </template>
          <template #body="slotProps">
            <span>{{
              (requestInformation.pageIndex - 1) * requestInformation.pageSize +
              slotProps.index +
              1
            }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="name"
          header="Họ tên"
          headerStyle="width: 200px;minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.HoTen"
              @change="layNguoiDungGomQuyenPhanTrang(true)"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.name }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="userName"
          header="Tên đăng nhập"
          headerStyle="width: 200px;minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.UserName"
              @change="layNguoiDungGomQuyenPhanTrang(true)"
            />
          </template>
          <template #body="slotProps">
            <router-link
              class="color-unset"
              :to="`${ROUTE_NAME.QUAN_TRI_HE_THONG.NGUOI_DUNG}/${slotProps.data.id}/xem`"
            >
              <span>{{ slotProps.data.userName }}</span>
            </router-link>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="email"
          header="Email"
          headerStyle="width: 300px;minWidth: 300px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.Email"
              @change="layNguoiDungGomQuyenPhanTrang(true)"
            />
          </template>
           <template #body="slotProps">
            <div v-html="slotProps.data.email"></div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="chucVu"
          header="Chức vụ"
          headerStyle="width: 250px;minWidth: 250px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.ChucVu"
              @change="layNguoiDungGomQuyenPhanTrang(true)"
            />
          </template>
          <template #body="slotProps">
            <div v-html="slotProps.data.chucVu"></div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="donVi"
          header="Đơn vị"
          headerStyle="width: 300px;minWidth:300px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.DonVi"
              @change="layNguoiDungGomQuyenPhanTrang(true)"
            />
          </template>
          <template #body="slotProps">
            <div v-html="slotProps.data.donVi"></div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="trangThai"
          header="trạng thái"
          headerStyle="width: 100px"
        >
          <template #body="slotProps">
            <div class="text-center">
              <b-form-checkbox
                class="text-center cursor-pointer"
                v-b-popover.hover.top="'Trạng thái hoạt động'"
                :checked="slotProps.data.trangThai"
                switch
                v-model="slotProps.data.trangThai"
                @change="handleChangeTrangThai(slotProps.data)"
              ></b-form-checkbox>
            </div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="isUsingSecretKey2FA"
          header="Xác thực OTP"
          headerStyle="width: 130px"
        >
          <template #body="slotProps">
            <div class="text-center" style="white-space: nowrap">
              <!-- UC10.3 vô hiệu hóa Soft OTP: badge THẮNG icon xác thực thường (exempt user được admin
                   vô hiệu OTP có chủ đích, không có nghĩa "chưa xác thực"). Text đổi từ "Miễn 2FA" -> "Vô
                   hiệu hóa" khớp SRS UC 10.3 wording. Backing field BE giữ nguyên IsTwoFactorExempt. -->
              <span
                v-if="slotProps.data.isTwoFactorExempt"
                class="badge badge-warning"
                v-b-popover.hover.top="'Tài khoản Soft OTP đã bị vô hiệu hóa (miễn xác thực 2 bước)'"
                >Vô hiệu hóa</span
              >
              <!-- UC10.1: TK chưa Active OTP (chưa từng verify mã hoặc đã reset). Text "Chờ kích hoạt" khớp
                   spec UC 10 vòng đời tài khoản Soft OTP. Badge màu vàng (state trung tính, không phải lỗi).
                   Không phân biệt "đã cấp mã còn hạn Redis" vs "chưa cấp mã" - backlog Phase 2 nếu cần. -->
              <span
                v-else-if="!slotProps.data.isUsingSecretKey2FA"
                class="badge badge-warning"
                v-b-popover.hover.top="'Chờ kích hoạt'"
                >Chờ kích hoạt</span
              >
              <span
                v-else
                class="badge badge-success"
                v-b-popover.hover.top="'Đã xác thực'"
                >Đã xác thực</span
              >
            </div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="thaoTac"
          header="Thao tác"
          headerStyle="width: 120px"
          v-if="
            hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.SUA) ||
            hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.XOA)
          "
        >
          <template #body="slotProps">
            <div class="text-center">
              <!-- Reset (hard) mã xác thực: LUÔN hiện khi có quyền RESET_2FA, KHÔNG phụ thuộc
                   isUsingSecretKey2FA. Trước đây điều kiện có `&& isUsingSecretKey2FA` -> tài khoản
                   ở trạng thái LỆCH (cờ=0 nhưng còn Device Active, vd do lost-update login) bị ẩn
                   nút reset -> admin không dọn được device kẹt (deadlock). Endpoint reset-setting-2fa
                   đã xóa sạch 3 tầng (Device + SecretKey2FA + cờ) vô điều kiện + step-up OTP admin,
                   nên cho nút luôn hiện là an toàn và giải được kẹt. -->
              <font-awesome-icon
                v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.RESET_2FA)"
                icon="redo"
                v-b-popover.hover.top="'Reset mã xác thực (xóa toàn bộ thiết bị, kể cả khi đã tắt 2FA)'"
                class="cursor-pointer color-red"
                @click="resetOtpOpenModal(slotProps.data.id)"
              />
              <!-- UC10.4: kích hoạt lại Soft OTP cho tài khoản đã bị vô hiệu (không còn dùng 2FA). -->
              <font-awesome-icon
                v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.RESET_2FA) && !slotProps.data.isUsingSecretKey2FA"
                icon="power-off"
                v-b-popover.hover.top="'Kích hoạt lại Soft OTP'"
                class="cursor-pointer color-green"
                @click="reactivateOtpOpenModal(slotProps.data.id)"
              />
              <!-- UC10.3 vô hiệu hóa Soft OTP + UC10.4 kích hoạt lại. Text tooltip khớp SRS wording thay
                   "Tắt/Bật 2FA" cũ. Reuse role reset-setting-2fa (đối xứng reset/reactivate). -->
              <font-awesome-icon
                v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.RESET_2FA) && !slotProps.data.isTwoFactorExempt"
                icon="user-slash"
                v-b-popover.hover.top="'Vô hiệu hóa Soft OTP cho người dùng này'"
                class="cursor-pointer color-red ml-2"
                @click="disable2FaOpenModal(slotProps.data.id)"
              />
              <font-awesome-icon
                v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.RESET_2FA) && slotProps.data.isTwoFactorExempt"
                icon="user-check"
                v-b-popover.hover.top="'Kích hoạt lại Soft OTP cho người dùng này'"
                class="cursor-pointer color-green ml-2"
                @click="enable2FaOpenModal(slotProps.data.id)"
              />
              <!-- UC10.2: cấp lại mã kích hoạt chỉ đúng cho TK CHƯA kích hoạt OTP (mã cũ hết hạn).
                   TK đã kích hoạt dùng nút "Reset mã xác thực" (redo) - BE cũng hard-block đường này. -->
              <font-awesome-icon
                v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.RESET_2FA) && !slotProps.data.isUsingSecretKey2FA"
                icon="envelope"
                v-b-popover.hover.top="'Cấp lại mã kích hoạt tới email người dùng'"
                class="cursor-pointer ml-2"
                @click="capMaKichHoat(slotProps.data.id)"
              />
              <font-awesome-icon
                v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.RESET_2FA)"
                icon="mobile-alt"
                v-b-popover.hover.top="'Quản lý thiết bị xác thực (khoá/mở)'"
                class="cursor-pointer ml-2"
                @click="quanLyThietBiOtp(slotProps.data.id)"
              />
              <font-awesome-icon
                icon="sync"
                v-b-popover.hover.top="'Reset mật khẩu'"
                class="cursor-pointer color-red ml-2"
                @click="resetPassWordModal(slotProps.data.userName)"
              />
              <router-link
                class="color-unset"
                :to="`${ROUTE_NAME.QUAN_TRI_HE_THONG.NGUOI_DUNG}/${slotProps.data.id}`"
              >
                <font-awesome-icon
                  icon="edit"
                  v-b-popover.hover.top="'Cập nhật người dùng'"
                  v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.SUA)"
                  class="cursor-pointer color-red ml-2"
                />
              </router-link>
              <font-awesome-icon
                icon="trash-alt"
                v-b-popover.hover.top="'Xóa người dùng'"
                v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.XOA)"
                class="cursor-pointer color-red ml-2"
                @click="handleXoaNguoiDung(slotProps.data)"
              />
            </div>
          </template>
        </Column>
        <template #empty
          ><div class="text-center">Không có dữ liệu</div></template
        >
        <template #loading
          ><div class="text-center">Đang tải dữ liệu ...</div>
        </template>
      </DataTable>
    </div>
    <BasePagination
      class="mt-3"
      :total-pages="totalPages"
      :total-rows="totalRows"
      :current-page="requestInformation.pageIndex"
      @changePages="onChangePages($event)"
      @changeNum="onChangeNum($event)"
    />

    <b-modal
      ref="themCanBoVaoNguoiDung"
      title="Thêm cán bộ vào người dùng"
      size="xl"
      :hide-footer="true"
    >
      <DanhSachCanBoThemVaoNguoiDung
        ref="danhSachQuyenKhongThuocNguoiDung"
        @themCanBoVaoNguoiDungThanhCong="themCanBoVaoNguoiDungThanhCong"
      />
    </b-modal>
    <ModalConfirm
      :title="chonNguoiDungXoa && chonNguoiDungXoa.userName"
      @confirmed="xoaNguoiDung"
    />
    <ModalUploadImportFile
      ref="modalImport"
      :dataType="'CanBo'"
      :title="'Cán bộ/User'"
      @refreshData="layNguoiDungGomQuyenPhanTrang"
    />
    <b-modal
      centered
      hide-footer
      footer-class="border-top-none"
      header-class="border-bottom-none"
      id="modal-reset"
      ref="modal-reset"
      size="md"
      :title="'Bạn có muốn ' + titleConfirm + '?'"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      <div class="font-size-14">
        <div class="w-100 text-right">
          <b-button
            @click="actionsConfirm()"
            class="btn btn-blue mr-2"
            :disabled="isLoading"
          >
            <font-awesome-icon icon="save" class="mr-1" /> Đồng ý
          </b-button>
          <b-button
            @click="hideModal()"
            class="btn btn-yellow"
            :disabled="isLoading"
          >
            <font-awesome-icon icon="sync" class="mr-1" />
            Hủy
          </b-button>
        </div>
      </div>
    </b-modal>
    <ModalResetOtpConfirm
      ref="modalResetOtp"
      @reset-done="layNguoiDungGomQuyenPhanTrang"
    />
    <ModalQuanLyThietBiUser ref="modalThietBiOtp" />
    <!-- OFF 2FA per-user (Approach A - 2026-08-11): modal tắt/bật lại 2FA cho user cụ thể. -->
    <ModalDisableEnable2Fa
      ref="modalDisableEnable"
      @done="layNguoiDungGomQuyenPhanTrang"
    />
  </div>
</template>

<script>
import ModalUploadImportFile from "@/components/modal/ModalUploadImportFile";
import BasePagination from "@/components/common/BasePagination";
import DanhSachCanBoThemVaoNguoiDung from "./DanhSachCanBoThemVaoNguoiDung";
import ModalConfirm from "@/components/modal/ModalConfirm";
import ModalResetOtpConfirm from "@/components/pages/quan-tri-he-thong/ModalResetOtpConfirm";
import ModalQuanLyThietBiUser from "@/components/pages/quan-tri-he-thong/ModalQuanLyThietBiUser";
import ModalDisableEnable2Fa from "@/components/pages/quan-tri-he-thong/ModalDisableEnable2Fa";
import { Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
  CAP_NHAT_ACTIVE_NGUOI_DUNG,
  XOA_USER_THANH_CONG,
} from "@/constants/message";
import {
  ROUTE_NAME,
  PERMISSION_NAME,
  PERMISSION_ROLE,
  BANG_NGUOI_DUNG,
  GIA_TRI_NGUOI_DUNG_TAB,
} from "@/constants/constants";
import { hasPermission } from "@/utils/permissionUtils";
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import { hasPermissionUser } from "@/utils/permissionUtils";

const userInfo = JSON.parse(localStorage.getItem("userInfo"));
export default {
  name: "QuanLyNguoiDung",
  components: {
    BasePagination,
    DanhSachCanBoThemVaoNguoiDung,
    ModalConfirm,
    Treeselect,
    ModalUploadImportFile,
    ModalResetOtpConfirm,
    ModalQuanLyThietBiUser,
    ModalDisableEnable2Fa,
  },
  data() {
    return {
      dataModal: null,
      titleConfirm: '',
      userInfo,
      isLoadingExport: false,
      PERMISSION_NAME,
      ROUTE_NAME: ROUTE_NAME,
      optionsDonVi: [],
      chonNguoiDungXoa: null,
      requestInformation: {
        isGetAll: false,
        filterBy: "",
        donViId: null,
        pageSize: 10,
        pageIndex: 1,
      },
      totalPages: 0,
      totalRows: 0,
      isLoadingTable: true,
      thongTinTraCuuNguoiPhanAnh: {},
      emptyHeaderTable: [
        BANG_NGUOI_DUNG.stt,
        BANG_NGUOI_DUNG.userName,
        BANG_NGUOI_DUNG.name,
        BANG_NGUOI_DUNG.donVi,
        BANG_NGUOI_DUNG.vaiTro,
        BANG_NGUOI_DUNG.trangThai,
      ],
      requestForm: {},
    };
  },
  computed: {
    ...mapGetters({
      nguoiDungGomQuyen: "user/nguoiDungGomQuyen",
      danhSachQuyenTheoNguoiDung: "permission/danhSachQuyenTheoNguoiDung",
      danhSachDonViSelect: "donVi/danhSachDonViSelect",
      danhSachDonVi: "donVi/danhSachDonVi",
    }),
    nguoiDungGomQuyenNoiBo() {
      return this.layNguoiDungGomQuyenNoiBo(this.nguoiDungGomQuyen);
    },
    fieldName() {
      return this.getFieldName();
    },
    hasPageData() {
      return !_isEmpty(this.nguoiDungGomQuyen.items);
    },
    hasUpdatePermission() {
      return hasPermission(
        this.danhSachQuyenTheoNguoiDung.items,
        PERMISSION_NAME.QUAN_TRI_HE_THONG,
        PERMISSION_ROLE.CAP_NHAT
      );
    },
    danhSachDonViBanDau() {
      if (!this.danhSachDonVi) {
        return [];
      }
      let danhSach = [];
      danhSach = this.danhSachDonVi.map((item) => {
        return {
          Task_ID: item.id,
          Task_Parent_ID: item.iD_DonVi_Cha,
          Label: item.tenDonVi,
          Childrens: [],
          ...item,
        };
      });
      return this.list_to_tree(danhSach);
    },
  },
  watch: {
    nguoiDungGomQuyen: {
      handler() {
        this.totalPages = this.nguoiDungGomQuyen.totalPage;
        this.totalRows = _isNil(this.nguoiDungGomQuyen.totalCount)
          ? 0
          : this.nguoiDungGomQuyen.totalCount;
      },
      immediate: true,
    },
    "requestInformation.pageIndex": {
      handler() {
        this.layNguoiDungGomQuyenPhanTrang();
      },
    },
  },
  created() {
    this.layNguoiDungGomQuyenPhanTrang();
    this.layDanhSachTheoDonViCha();
    this.$store.dispatch("donVi/layDanhSachDonViCha", {}).then(() => {});
  },
  methods: {
    // Confirm modal-reset chung giờ CHỈ dùng cho reset mật khẩu (reset OTP đã tách sang ModalResetOtpConfirm).
    actionsConfirm() {
      this.resetPassword(this.dataModal);
    },
    hasPermissionUser,
    resetPassword(userName) {
      this.$store
        .dispatch("user/resetMatKhau", {
          userName: userName,
        })
        .then((res) => {
          if (res.data.succeeded) {
            this.hideModal()
            this.$toasted.clear();
            this.$toasted.global.showSuccessMessage({
              message: "Reset mật khẩu thành công",
            });
          }
        })
        .catch(() => {
          this.hideModal()
          this.$toasted.clear();
          this.$toasted.global.showSuccessMessage({
            message: "Thao tác thất bại",
          });
        });
    },
    hideModal() {
      this.$bvModal.hide("modal-reset");
    },
    // Phase 7A: reset OTP cần step-up (OTP admin) -> mở modal riêng ModalResetOtpConfirm,
    // KHÔNG dùng confirm modal-reset chung (chung đó giờ chỉ còn reset mật khẩu).
    resetOtpOpenModal(data) {
      this.$refs.modalResetOtp.showModal(data);
    },
    // UC10.4: kích hoạt lại Soft OTP - dùng chung ModalResetOtpConfirm với mode='reactivate'
    // (cùng UI step-up OTP admin + lý do, đổi text + gọi endpoint reactivate-2fa).
    reactivateOtpOpenModal(data) {
      this.$refs.modalResetOtp.showModal(data, "reactivate");
    },
    // OFF 2FA per-user (Approach A - 2026-08-11): mở modal tắt/bật lại 2FA cho user cụ thể.
    disable2FaOpenModal(userId) {
      this.$refs.modalDisableEnable.showModal(userId, "disable");
    },
    enable2FaOpenModal(userId) {
      this.$refs.modalDisableEnable.showModal(userId, "enable");
    },
    // Phase 10 UC12: mở modal quản lý thiết bị OTP của user (admin khoá/mở từng thiết bị, step-up OTP).
    quanLyThietBiOtp(userId) {
      this.$refs.modalThietBiOtp.showModal(userId);
    },
    // Phase 7C UC11: admin gửi mã kích hoạt tới email người dùng (mã KHÔNG hiện cho admin).
    capMaKichHoat(userId) {
      this.$bvModal
        .msgBoxConfirm("Gửi mã kích hoạt xác thực 2 bước tới email của người dùng?", {
          title: "Xác nhận",
          okTitle: "Gửi",
          cancelTitle: "Huỷ",
          centered: true,
        })
        .then((ok) => {
          if (!ok) return;
          this.$store
            .dispatch("common/issueActivation", { userId: userId })
            .then((res) => {
              if (res.succeeded) {
                this.$toasted.clear();
                this.$toasted.global.showSuccessMessage({
                  message: "Đã gửi mã kích hoạt tới email người dùng",
                });
              }
            })
            .catch((err) => {
              this.$toasted.clear();
              this.$toasted.global.showErrorMessage({
                message: (err && err.data && err.data.message) || "Không gửi được mã kích hoạt",
              });
            });
        });
    },
    resetPassWordModal(userName) {
      this.dataModal = userName
      this.titleConfirm = `reset mật khẩu ${userName}`
      this.$bvModal.show("modal-reset");
    },
    onChangeGetAll() {
      this.$nextTick(() => {
        this.layNguoiDungGomQuyenPhanTrang();
      });
    },
    themMoi() {
      this.$router.push({
        path: `${ROUTE_NAME.QUAN_TRI_HE_THONG.NGUOI_DUNG}/tao-moi`,
        params: {
          item: `${GIA_TRI_NGUOI_DUNG_TAB.THEM_MOI_NGUOI_DUNG}`,
        },
      });
    },
    openImport() {
      this.$refs["modalImport"].showModal();
    },
    openExport() {
      let typeExport = "NguoiDung";
      this.isLoadingExport = true;
      this.$store
        .dispatch("importService/exportData", {
          type: typeExport,
          searchRequest: {
            ...this.requestInformation,
            ...this.requestForm,
          },
        })
        .then((res) => {
          let url = window.URL.createObjectURL(new Blob([res.data]));
          let link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Export${typeExport}.xlsx`);
          document.body.appendChild(link);
          link.click();
        });
    },
    treeselectClass(valid) {
      return {
        "treeselect-invalid": valid,
      };
    },
    normalizer(node) {
      return {
        children: _isEmpty(node.children) ? undefined : node.children,
      };
    },
    list_to_tree(list) {
      if (list.length > 0) {
        var map = {},
          node,
          roots = [],
          i;
        for (i = 0; i < list.length; i += 1) {
          map[list[i].Task_ID] = i; // initialize the map
          list[i].Childrens = []; // initialize the children
        }
        for (i = 0; i < list.length; i += 1) {
          node = list[i];
          if (node.Task_Parent_ID !== this.guidEmpty) {
            // if you have dangling branches check that map[node.parentId] exists
            if (list[map[node.Task_Parent_ID]] != null) {
              list[map[node.Task_Parent_ID]].Childrens.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            } else {
              roots.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            }
          } else {
            roots.push({
              id: node.Task_ID,
              label: node.Label,
              parentId: node.Task_Parent_ID,
              children: node.Childrens,
            });
          }
        }
        return roots;
      }
      return list;
    },
    themCanBoVaoNguoiDungThanhCong() {
      this.$refs["themCanBoVaoNguoiDung"].hide();
      this.layNguoiDungGomQuyenPhanTrang();
    },
    moFormThemCanBoVaoNguoiDung() {
      this.$refs["themCanBoVaoNguoiDung"].show();
    },
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layNguoiDungGomQuyenPhanTrang();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
    },
    layNguoiDungGomQuyenPhanTrang(resetPageIndex) {
      if (resetPageIndex === true) {
        this.requestInformation.pageIndex = 1;
      }
      this.isLoadingTable = true;
      this.$store
        .dispatch("user/layNguoiDungGomQuyen", {
          ...this.requestInformation,
          ...this.requestForm,
        })
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    layDanhSachTheoDonViCha() {
      console.log("created");
      return this.$store
        .dispatch("donVi/layDanhSachTheoDonViCha", {
          soCap: 999,
        })
        .then(() => {});
    },
    layNguoiDungGomQuyenNoiBo(nguoiDungGomQuyen) {
      if (_isEmpty(nguoiDungGomQuyen.items)) {
        return [];
      }
      return nguoiDungGomQuyen.items.map((item, index) => {
        return {
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          canBoId: _isNil(item.id) ? "" : item.id,
          id: _isNil(item.id) ? "" : item.id,
          userName: _isNil(item.userName) ? "" : item.userName,
          name: _isNil(item.fullName) ? "" : item.fullName,
          email: _isNil(item.email) ? "" : item.email,
          chucVu: _isNil(item.chucVu) ? "" : item.chucVu,
          donVi: _isNil(item.donVi) ? "" : item.donVi,
          trangThai: _isNil(item.isActivate) ? "" : item.isActivate,
          isUsingSecretKey2FA: _isNil(item.isUsingSecretKey2FA) ? "" : item.isUsingSecretKey2FA,
          // OFF 2FA per-user (Approach A - 2026-08-11): field mới từ BE - PHẢI liệt kê tường minh ở
          // đây (projection thủ công), thiếu dòng này = badge/nút Miễn 2FA luôn undefined dù BE trả đúng.
          isTwoFactorExempt: _isNil(item.isTwoFactorExempt) ? false : item.isTwoFactorExempt,
          profileId: _isNil(item.profileId) ? "" : item.profileId,
          thaoTac: "thaoTac",
        };
      });
    },
    getFieldName() {
      if (_isEmpty(this.nguoiDungGomQuyenNoiBo)) {
        return [];
      }
      return Object.keys(this.nguoiDungGomQuyenNoiBo[0])
        .filter((key) => key !== "id" && key !== "canBoId")
        .map((key) => {
          return {
            key: key,
            label: BANG_NGUOI_DUNG[key],
            tdClass: ["stt"].includes(key) ? "center" : "",
          };
        });
    },
    handleChangeTrangThai(item) {
      const payload = {
        ids: [item.id],
        isActivate: !item.trangThai,
      };
      this.$store
        .dispatch("user/capNhatActiveNguoiDung", payload)
        .then((res) => {
          if (res.data.succeeded) {
            this.$toasted.clear();
            this.$toasted.global.showSuccessMessage({
              message: CAP_NHAT_ACTIVE_NGUOI_DUNG,
            });
          }
        });
    },

    handleXoaNguoiDung(item) {
      this.chonNguoiDungXoa = item;
      this.$bvModal.show("modal-confirm");
    },
    xoaNguoiDung(confirm) {
      if (confirm) {
        this.$bvModal.hide("modal-confirm");
        const payload = {
          id: this.chonNguoiDungXoa.canBoId,
        };
        this.$store.dispatch("user/xoaNguoiDung", payload).then((res) => {
          if (res.data.succeeded) {
            this.layNguoiDungGomQuyenPhanTrang();
            this.$toasted.clear();
            this.$toasted.global.showSuccessMessage({
              message: XOA_USER_THANH_CONG,
            });
          }
        });
      }
    },
  },
};
</script>
